module.exports = __webpack_public_path__ + "img/banner6.98c7e867.png";